/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PartnerWaitForApprovalPage = lazyLoad(
  () => import('./index'),
  module => module.PartnerWaitForApprovalPage
);
